import {INativebaseConfig} from "native-base";

export const nativeBaseConfig : INativebaseConfig = {
    dependencies: {
        'linear-gradient': require('expo-linear-gradient').LinearGradient,
    },
    strictMode: 'error'
};